iScreenWizard.controller('FeedbackOverzichtController', function ($scope, $state, $mdDialog, $filter, Ajax, ErrorHandler, Dictionary, userService, Testafnamestatus, WizardFeedbackSessie, nieuwe360FeedbackService) {

    var pagesize = 20;

    $scope.userService = userService;
    $scope.feedback = nieuwe360FeedbackService.model;

    $scope.testafnamestatussen = [];

    $scope.searchTerm = '';
    $scope.aanmaakdatum_totenmet = new Date();
    $scope.aanmaakdatum_van = new Date(
        $scope.aanmaakdatum_totenmet.getFullYear()-1,
        $scope.aanmaakdatum_totenmet.getMonth(),
        $scope.aanmaakdatum_totenmet.getDate()
    );

    $scope.feedbacksessies = [];
    $scope.feedbacksessieFilters = {};
    $scope.feedbacksessiePage = 1;
    $scope.feedbacksessieMorePages = true;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    $scope.refresh = function() {
        $scope.loadFeedbackSessies();

        Testafnamestatus.all().then(function(testafnamestatussen) {
            angular.forEach(testafnamestatussen, function(testafnamestatus) {
                $scope.testafnamestatussen[testafnamestatus.id] = testafnamestatus;
            });
        });
    };

    $scope.loadMoreFeedbackSessies = function() {
        $scope.feedbacksessiePage = $scope.feedbacksessiePage+1;
        $scope.loadFeedbackSessies();
    };

    $scope.loadFeedbackSessies = function() {
        params = {
            wizardfeedbackrapporttype_id: $scope.feedback.wizardfeedbackrapporttype.id,
            pagesize: pagesize,
            page: $scope.feedbacksessiePage,
            orderby: 'id',
            orderdesc: true
        };
        if ($scope.searchTerm.length > 0) {
            params.searchterm = $scope.searchTerm;
        }
        if ($scope.aanmaakdatum_van) {
            params.aanmaakdatum_van = $filter('date')(new Date($scope.aanmaakdatum_van),'dd-MM-yyyy');
        }
        if ($scope.aanmaakdatum_totenmet) {
            params.aanmaakdatum_totenmet = $filter('date')(new Date($scope.aanmaakdatum_totenmet),'dd-MM-yyyy');
        }
        WizardFeedbackSessie.all(params).then(function (feedbacksessies) {
            angular.forEach(feedbacksessies, function(feedbacksessie) {
                feedbacksessie.rapport_te_downloaden = false;
                angular.forEach(feedbacksessie.feedbacktestafnames, function(feedbacktestafname) {
                    if (feedbacktestafname.testafnamestatus_id == 4) {
                        feedbacksessie.rapport_te_downloaden = true;
                    }
                });
                $scope.feedbacksessies.push(feedbacksessie);
            });
            if (feedbacksessies.length < pagesize) {
                $scope.feedbacksessieMorePages = false;
            }
        });
    };

    $scope.searchKandidaten = function() {
        $scope.feedbacksessies = [];
        $scope.feedbacksessieMorePages = true;
        $scope.feedbacksessiePage = 1;
        $scope.loadFeedbackSessies();
    };

    var downloadRapport = function(feedbacksessie) {
        $mdDialog.show({
            controller: DownloadRapportDialogController,
            locals: {
                feedbacksessie: feedbacksessie
            },
            templateUrl: '/360-feedback/download-rapport',
            parent: angular.element(document.body),
            clickOutsideToClose: true
        });
    };

    $scope.downloadRapport = downloadRapport;

    function DownloadRapportDialogController($scope, WizardFeedback, feedbacksessie) {
        $scope.wizardfeedbacksessie_id = feedbacksessie.id;
        $scope.stillLoading = true;
        $scope.downLoadUrl = '';
        $scope.mainBlocks = [];
        $scope.mainBlocksEnties = [];

        WizardFeedback.downloadReport(feedbacksessie).then(function (response) {
            $scope.stillLoading = false;
            if (ErrorHandler.hasErrors(response)) {
                ErrorHandler.showDialog(response);
            } else {
                $scope.downLoadUrl = baseUrl + response.data.file_url + '?jwt=' + userService.getToken();
            }
        });

    };

    $scope.selectFeedbackSessie = function(feedbacksessie) {
        $mdDialog.show({
            controller: ShowFeedbackSessieDialogController,
            locals: {
                feedbacksessie: feedbacksessie,
                testafnamestatussen: $scope.testafnamestatussen
            },
            templateUrl: '/360-feedback/show-feedback',
            parent: angular.element(document.body),
            clickOutsideToClose: true
        });
    };

    function ShowFeedbackSessieDialogController($scope, feedbacksessie, testafnamestatussen, Rapporttemplate) {
        $scope.feedbacksessie = feedbacksessie;
        $scope.testafnamestatussen = testafnamestatussen;

        if (feedbacksessie.brontestafname.wizardrapporttemplate_id > 0) {
            Rapporttemplate.get(feedbacksessie.brontestafname.wizardrapporttemplate_id).then(function (rapporttemplate) {
                $scope.feedbacksessie.brontestafname.rapporttemplate = rapporttemplate;
            });
        }

        if (feedbacksessie.rapporttemplate_id > 0) {
            Rapporttemplate.get(feedbacksessie.rapporttemplate_id).then(function (rapporttemplate) {
                $scope.feedbacksessie.feedbackrapporttemplate = rapporttemplate;
            });
        }

        $scope.downloadRapport = downloadRapport;

    };


});